<template>
    <div>
        <v-container v-if="isLoading">
            <v-progress-linear color="blue darken-5" indeterminate height="6">
            </v-progress-linear>
            <v-col>
                <v-skeleton-loader
                    type="list-item-three-line, card-heading, image"
                ></v-skeleton-loader>
            </v-col>
        </v-container>
        <div v-if="isLoading == false">
            <v-layout row wrap>
                <v-alert outlined color="#0e3d85">
                    Nie wiesz jaki kierunek wybrać ? Powiedz nam z jakiego
                    przedmiotu masz zdany egzamin maturalny, a my powiemy Ci co
                    możesz studiować! Znajdź kierunek studiów dla siebie.

                    <v-alert>
                        Czy wiesz, że matura z chemii nie przekreśla Twojej
                        szansy na humanistyczne studia, a ze zdaną matematyką
                        możesz studiowac kosmetologię ?
                    </v-alert>
                    <b></b>
                    <div class="text-center">
                        <b> Wybierz kierunki studiów według</b>
                        <br />
                        <v-btn
                            style="text-transform: unset !important"
                            rounded
                            color="#0e3d85"
                            dark
                            large
                            v-if="this.action == 2"
                            @click="action = 1"
                            >poziomu studiów
                        </v-btn>

                        <v-btn
                            style="text-transform: unset !important"
                            v-if="this.action == 1"
                            rounded
                            color="#c20444"
                            dark
                            @click="changeMajorsHandle()"
                        >
                            przedmiotów zdawanych na maturze
                        </v-btn>
                    </div>
                </v-alert>

                <div v-if="this.action == 1">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-expansion-panels>
                                    <v-row class="justify-start">
                                        <h2 class="" style="border: none">
                                            Przedmioty maturalne
                                        </h2>
                                    </v-row>
                                    <v-expansion-panel
                                        v-for="(message, i) in this.examList"
                                        :key="i"
                                    >
                                        <v-expansion-panel-header
                                            @click="
                                                getMajorHandle(
                                                    message.idMajors,
                                                    message.name
                                                )
                                            "
                                        >
                                            <v-row
                                                align="center"
                                                class="spacer"
                                                no-gutters
                                            >
                                                <v-col cols="2" sm="2" md="1">
                                                    <v-icon
                                                        large
                                                        :color="message.color"
                                                        v-text="message.icon"
                                                    ></v-icon>
                                                </v-col>

                                                <v-col>
                                                    {{ message.name }}
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <span
                                                v-for="(study,
                                                i) in filteredStudyList"
                                            >
                                                <v-chip
                                                    class="ma-1"
                                                    @click="
                                                        getPostData(
                                                            getLastSegment(
                                                                study.url
                                                            )
                                                        )
                                                    "
                                                >
                                                    {{ study.fieldOfStudy }}
                                                </v-chip>
                                            </span>
                                            <div v-if="post">
                                                <v-img
                                                    class="mb-6"
                                                    :aspect-ratio="16 / 9"
                                                    max-height="640px"
                                                    :src="
                                                        '/uploads/' +
                                                            featuredImage
                                                    "
                                                    :alt="featuredImageAltText"
                                                    :aria-label="
                                                        featuredImageAltText
                                                    "
                                                ></v-img>
                                                <v-card-text v-html="post">
                                                </v-card-text>
                                                <!--<v-btn
                                                    class="ml-6"
                                                    href="https://irk.ans.edu.pl/pl/auth/register/consent/"
                                                    target="_blank"
                                                    >Zapisz się</v-btn>
                                                -->
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <!--courseOfStudy-->
                <div v-if="this.action == 2">
                    <v-row align="center">
                        <v-col class="pr-3 d-flex" cols="12" md="12" sm="12">
                            <v-select
                                v-model="levelOfStudyHandle"
                                class="mr-1"
                                item-text="title"
                                item-value="id"
                                :items="levelOfStudyList"
                                label="Wybierz poziom studiów"
                                outlined
                            ></v-select>
                        </v-col>
                        <v-col class="pr-3 d-flex" cols="12" md="10" sm="12">
                            <v-select
                                v-model="formOfStudyHandle"
                                @click="clearStudyList"
                                class="mr-1"
                                item-text="title"
                                item-value="id"
                                :items="formOfStudyList"
                                label="Wybierz formę studiów"
                                outlined
                            ></v-select>
                        </v-col>
                        <div></div>
                        <v-col
                            class="justify-end mt-n4 d-flex"
                            cols="2"
                            md="2"
                            sm="1"
                        >
                            <v-switch
                                v-model="switchHandle"
                                :label="recruitmentSwitchLabel"
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row class="mx-auto pa-3" id="study">
                        <div
                            class="pb-3 black--text text-truncate hidden-md-and-up"
                        >
                            <v-chip label small>S</v-chip> studia stacjonarne
                            <v-chip label small>N</v-chip> studia niestacjonarne
                        </div>
                        <v-col
                            v-if="this.fieldOfStudy == 'Pielęgniarstwo*'"
                            cols="12"
                        >
                            <v-alert
                                border="right"
                                colored-border
                                type="info"
                                elevation="2"
                            >
                                *Kierunek zostanie uruchomiony po nadaniu
                                uprawnienia do prowadzenia studiów na tym
                                kierunku przez Ministerstwo Edukacji i Nauki
                            </v-alert>
                        </v-col>

                        <v-col
                            v-if="
                                this.filteredStudyList.length == 0 &&
                                    this.formOfStudy != null &&
                                    this.levelOfStudy != null
                            "
                            cols="12"
                        >
                            <v-alert
                                border="right"
                                colored-border
                                type="error"
                                elevation="2"
                                >Nie znaleziono żadnego kierunku, który spełnia
                                wskazane kryteria.</v-alert
                            >
                        </v-col>
                        <v-expansion-panels>
                            <v-expansion-panel
                                v-for="(message, i) in this.filteredStudyList"
                                :key="i"
                                @click="
                                    getPostData(getLastSegment(message.url))
                                "
                            >
                                <v-expansion-panel-header
                                    ><v-row
                                        align="center"
                                        class="spacer"
                                        no-gutters
                                    >
                                        <v-col cols="2" sm="2" md="1">
                                            <v-icon
                                                large
                                                :color="message.color"
                                                v-text="message.icon"
                                            ></v-icon>
                                        </v-col>
                                        <v-col
                                            class="text-wrap"
                                            cols="4"
                                            sm="3"
                                        >
                                            <strong
                                                v-html="message.fieldOfStudy"
                                            ></strong>
                                            <div class="hidden-md-and-up">
                                                <span
                                                    v-if="
                                                        message.recruitment ==
                                                            true
                                                    "
                                                    outlined
                                                    >nabór letni</span
                                                >
                                                <span
                                                    v-if="
                                                        message.recruitment !=
                                                            true
                                                    "
                                                    outlined
                                                    >nabór zimowy</span
                                                >
                                            </div>
                                        </v-col>
                                        <v-col
                                            class="black--text text-truncate hidden-sm-and-down"
                                        >
                                            {{ message.title }}
                                        </v-col>
                                        <v-col
                                            class="hidden-md-and-up"
                                            cols="2"
                                            sm="2"
                                        >
                                            <v-chip
                                                label
                                                small
                                                v-if="
                                                    message.formOfStudy == 'S'
                                                "
                                                >S</v-chip
                                            >
                                            <v-chip
                                                label
                                                small
                                                v-if="
                                                    message.formOfStudy == 'N'
                                                "
                                                >N</v-chip
                                            >
                                        </v-col>
                                        <v-col
                                            class="hidden-md-and-up"
                                            cols="3"
                                            sm="3"
                                        >
                                            {{ message.title }}
                                        </v-col>

                                        <v-col class="hidden-sm-and-down">
                                            <v-chip
                                                small
                                                color="black"
                                                v-if="
                                                    message.formOfStudy == 'S'
                                                "
                                                outlined
                                                >stacjonarne</v-chip
                                            >
                                            <v-chip
                                                small
                                                color="black"
                                                v-if="
                                                    message.formOfStudy == 'N'
                                                "
                                                outlined
                                                >niestacjonarne</v-chip
                                            >
                                            <v-chip
                                                small
                                                v-if="
                                                    message.recruitment == true
                                                "
                                                color="red darken-5"
                                                outlined
                                                >nabór letni</v-chip
                                            >
                                            <v-chip
                                                small
                                                v-if="
                                                    message.recruitment == false
                                                "
                                                color="blue darken-5"
                                                outlined
                                                >nabór zimowy</v-chip
                                            >
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-img
                                        class="mb-6"
                                        :aspect-ratio="16 / 9"
                                        max-height="640px"
                                        :src="'/uploads/' + featuredImage"
                                        :alt="featuredImageAltText"
                                        :aria-label="featuredImageAltText"
                                    ></v-img>
                                    <v-card-text v-html="post"> </v-card-text>
                                    <!--<v-btn
                                        v-if="message.btn"
                                        class="ml-6"
                                        :href="message.btn"
                                        target="_blank"
                                        >Zapisz się</v-btn
                                    >-->
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                </div>
                <!--courseOfStudy-->
            </v-layout>
        </div>
    </div>
</template>
<script>
//import { mapGetters } from "vuex";
import { bootstrap } from "vue-gtag";
export default {
    components: {},
    data() {
        return {
            action: 1,
            alert: false,
            isLoading: false,
            recruitmentSwitch: true,
            levelOfStudy: null,
            formOfStudy: null,
            fieldOfStudy: null,
            post: null,
            featuredImage: null,
            featuredImageAltText: null,
            filteredStudyList: [],
            idMajors: "",

            levelOfStudyList: [
                {
                    id: "I",
                    title: "Studia I stopnia"
                },
                {
                    id: "II",
                    title: "Studia magisterskie"
                }
                /*
                {
                    id: "IIj",
                    title: "Jednolite studia magisterskie",
                },
                */
            ],

            formOfStudyList: [
                {
                    id: "S",
                    title: "Stacjonarne"
                },
                {
                    id: "N",
                    title: "Niestacjonarne"
                }
            ],

            examList: [
                {
                    name: "język polski",
                    color: "#0e3d85",
                    icon: "mdi-feather",
                    idMajors: [1, 2, 3, 4, 5, 6, 8, 9, 11, 13]
                },
                {
                    name: "matematyka",
                    color: "#0e3d85",
                    icon: "mdi-math-compass",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "biologia",
                    color: "#0e3d85",
                    icon: "mdi-microscope",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "chemia",
                    color: "#0e3d85",
                    icon: "mdi-test-tube",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "fizyka",
                    color: "#0e3d85",
                    icon: "mdi-atom",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "geografia",
                    color: "#0e3d85",
                    icon: "mdi-globe-model",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "historia",
                    color: "#0e3d85",
                    icon: "mdi-book-edit-outline",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "Wiedza o społeczeństwie",
                    color: "#0e3d85",
                    icon: "mdi-human-capacity-decrease",
                    idMajors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13]
                },
                {
                    name: "historia sztuki",
                    color: "#0e3d85",
                    icon: "mdi-pillar",
                    idMajors: [2, 6]
                },
                {
                    name: "informatyka",
                    color: "#0e3d85",
                    icon: "mdi-state-machine",
                    idMajors: [2, 3, 6, 8]
                }
            ],

            studyList: [
                {
                    fieldOfStudy: "Administracja",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true, //nabór letni
                    IdMajor: 1,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/administracja",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/ADM-SLP/?from=field:ADM"
                },
                {
                    fieldOfStudy: "Administracja",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/administracja",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/ADM-NLP/?from=field:ADM"
                },
                {
                    fieldOfStudy: "Administracja",
                    formOfStudy: "S",
                    levelOfStudy: "II",
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia magisterskie",
                    url:
                        "/kandydat/studia-magisterskie/administracja-ii-stopnia",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IIST_1/programme/ADM-SMP/?from=field:ADM"
                },
                {
                    fieldOfStudy: "Administracja",
                    formOfStudy: "N",
                    levelOfStudy: "II",
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia magisterskie",
                    url:
                        "/kandydat/studia-magisterskie/administracja-ii-stopnia",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IIST_1/programme/ADM-NMP/?from=field:ADM"
                },
                {
                    fieldOfStudy: "Architektura wnętrz",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 2,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/architektura-wnetrz",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/ARW-SLP/?from=field:ARW"
                },

                {
                    fieldOfStudy: "Bezpieczeństwo wewnętrzne",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 3,
                    title: "studia licencjackie",
                    url:
                        "/kandydat/studia-licencjackie/bezpieczenstwo-wewnetrzne",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/BEW-SLP/?from=field:BEW"
                },

                {
                    fieldOfStudy: "Bezpieczeństwo wewnętrzne",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia licencjackie",
                    url:
                        "kandydat/studia-licencjackie/bezpieczenstwo-wewnetrzne",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/BEW-NLP/?from=field:BEW"
                },
                {
                    fieldOfStudy: "Dietetyka",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 4,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/dietetyka",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/BEW-NLP/?from=field:BEW"
                },
                {
                    fieldOfStudy: "Dietetyka",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/dietetyka",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/DIE-NLP/?from=field:DIE"
                },
                {
                    fieldOfStudy: "Filologia",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 5,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/filologia-angielska",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/FIL-SLP/?from=field:FIL"
                },
                {
                    fieldOfStudy: "Filologia",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/filologia-angielska",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/FIL-NLP/?from=field:FIL"
                },
                {
                    fieldOfStudy: "Grafika użytkowa z reklamą",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 6,
                    title: "studia licencjackie",
                    url:
                        "/kandydat/studia-licencjackie/grafika-uzytkowa-z-reklama-studia",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/GUR-SLP/?from=field:GUR"
                },
                {
                    fieldOfStudy: "Grafika użytkowa z reklamą",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 0,
                    title: "studia licencjackie",
                    url:
                        "kandydat/studia-licencjackie/grafika-uzytkowa-z-reklama-studia",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/GUR-NLP/?from=field:GUR"
                },
                {
                    fieldOfStudy: "Kosmetologia",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    color: "grey",
                    icon: "mdi-school-outline",
                    recruitment: true,
                    IdMajor: 7,
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/kosmetologia",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/KOS-SLP/?from=field:KOS"
                },
                {
                    fieldOfStudy: "Kosmetologia",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 0,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/kosmetologia",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/KOS-NLP/?from=field:KOS"
                },
                {
                    fieldOfStudy: "Logistyka",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 8,
                    color: "black",
                    icon: "mdi-school-outline",
                    title: "studia inżynierskie",
                    url: "/kandydat/studia-inzynierskie/logistyka-2",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/LOG-SIP/?from=field:LOG"
                },
                {
                    fieldOfStudy: "Logistyka",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 0,
                    color: "black",
                    icon: "mdi-school-outline",
                    title: "studia inżynierskie",
                    url: "/kandydat/studia-inzynierskie/logistyka-2",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/LOG-NIP/?from=field:LOG"
                },
                {
                    fieldOfStudy: "Logistyka",
                    formOfStudy: "S",
                    levelOfStudy: "II",
                    recruitment: false,
                    IdMajor: 0,
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    title: "studia magisterskie",
                    url: "/kandydat/studia-magisterskie/logistyka-ii-stopnia",
                    btn: ""
                },
                {
                    fieldOfStudy: "Logistyka",
                    formOfStudy: "N",
                    levelOfStudy: "II",
                    IdMajor: 0,
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    recruitment: false,
                    title: "studia magisterskie",
                    url: "kandydat/studia-magisterskie/logistyka-ii-stopnia",
                    btn: ""
                },
                {
                    fieldOfStudy: "Pedagogika",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 9,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/pedagogika",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/PED-SLP/?from=field:PED"
                },
                {
                    fieldOfStudy: "Pedagogika",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 0,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/pedagogika",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/PED-NLP/?from=field:PED"
                },
                {
                    fieldOfStudy: "Pielęgniarstwo",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 11,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/pielegniarstwo",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/PIE-SPP/?from=field:PIE"
                },
                {
                    fieldOfStudy: "Pielęgniarstwo",
                    formOfStudy: "S",
                    levelOfStudy: "II",
                    recruitment: true,
                    IdMajor: 0,
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    title: "studia magisterskie",
                    url: "/kandydat/studia-magisterskie/pielegniarstwo-2",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_JSM_1/programme/PPW-SMP/?from=field:PPW"
                },
                {
                    fieldOfStudy: "Pielęgniarstwo",
                    formOfStudy: "N",
                    levelOfStudy: "II",
                    recruitment: true,
                    IdMajor: 0,
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    title: "studia magisterskie",
                    url: "/kandydat/studia-magisterskie/pielegniarstwo-2",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_JSM_1/programme/PPW-SMP/?from=field:PPW"
                },

                {
                    fieldOfStudy: "Pedagogika przedszkolna i wczesnoszkolna",
                    formOfStudy: "S",
                    levelOfStudy: "IIj",
                    recruitment: true,
                    IdMajor: 10,
                    color: "red darken-5",
                    icon: "mdi-school-outline",
                    title: "Jednolite studia magisterskie",
                    url:
                        "/kandydat/jednolite-studia-magisterskie/pedagogika-przedszkolna-i-wczesnoszkolna-2",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_JSM_1/programme/PPW-SMP/?from=field:PPW"
                },

                {
                    fieldOfStudy: "Techniki dentystyczne",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 12,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/studia-licencjackie/techniki-dentystyczne",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/TED-SLP/?from=field:TED"
                },
                {
                    fieldOfStudy: "Zarządzanie",
                    formOfStudy: "S",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 13,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/kierunki-studiow/zarzadzanie",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/ZAR-SLP/?from=field:ZAR"
                },
                {
                    fieldOfStudy: "Zarządzanie",
                    formOfStudy: "N",
                    levelOfStudy: "I",
                    recruitment: true,
                    IdMajor: 0,
                    color: "grey",
                    icon: "mdi-school-outline",
                    title: "studia licencjackie",
                    url: "/kandydat/kierunki-studiow/zarzadzanie",
                    btn:
                        "https://irk.ans.edu.pl/pl/offer/REK2023_2024L_IST_1/programme/ZAR-NLP/?from=field:ZAR"
                }
            ]
        };
    },

    methods: {
        track_btn(category, label) {
            this.$gtag.event("Kandydat", {
                event_category: category,
                event_label: label
            });
        },

        changeMajorsHandle() {
            (this.filteredStudyList = this.studyList), (this.action = 2);
        },
        clearStudyList() {
            this.filteredStudyList = this.studyList;
            (this.post = null),
                (this.featuredImage = null),
                (this.featuredImageAltText = null);
        },

        getMajorHandle(idMajors, courseName) {
            (this.post = null),
                (this.featuredImage = null),
                (this.featuredImageAltText = null);

            if (idMajors) {
                let filteredMajorArray = [];
                let ConcatenatedArray = [];
                idMajors.forEach(idMajor => {
                    filteredMajorArray = this.myFilter(idMajor);
                    ConcatenatedArray = ConcatenatedArray.concat(
                        filteredMajorArray
                    );
                });

                this.filteredStudyList = ConcatenatedArray;

                bootstrap().then(
                    gtag => {
                        this.track_btn("Przedmioty maturalne", courseName);
                    }
                    //console.log("track Przedmioty maturalne", courseName)
                );
            }
        },

        myFilter(idMajor) {
            let m;
            m = this.studyList.filter(function(index) {
                return index.IdMajor == idMajor;
            });
            return m;
        },

        filter: function() {
            let formOfStudy = this.formOfStudy;
            let levelOfStudy = this.levelOfStudy;
            let recruitmentSwitch = this.recruitmentSwitch;

            this.filteredStudyList = this.studyList.filter(function(index) {
                return index.recruitment == recruitmentSwitch;
            });

            if (levelOfStudy) {
                this.filteredStudyList = this.filteredStudyList.filter(function(
                    index
                ) {
                    return index.levelOfStudy == levelOfStudy;
                });
                if (formOfStudy) {
                    this.filteredStudyList = this.filteredStudyList.filter(
                        function(index) {
                            return index.formOfStudy == formOfStudy;
                        }
                    );
                }
            }

            if (formOfStudy) {
                this.filteredStudyList = this.filteredStudyList.filter(function(
                    index
                ) {
                    return index.formOfStudy == formOfStudy;
                });
                if (levelOfStudy) {
                    this.filteredStudyList = this.filteredStudyList.filter(
                        function(index) {
                            return index.levelOfStudy == levelOfStudy;
                        }
                    );
                }
            }
            return this.filteredStudyList;
        },

        getLastSegment(urlSlug) {
            let lastSegment;
            lastSegment = urlSlug.split("/").pop();
            return lastSegment;
        },

        async getPostData(categoryDetail) {
            const [postData] = await Promise.all([
                this.callApi("get", `/details/${categoryDetail}`)
            ]);
            if (postData.status == 200) {
                this.post = postData.data.postData.post;
                this.featuredImage = postData.data.postData.featuredImage;
                this.featuredImageAltText = postData.data.postData.altText;
            }
            bootstrap().then(
                gtag => {
                    this.track_btn("Informacja o kierunku", categoryDetail);
                }
                //console.log("track Informacja o kierunku", categoryDetail)
            );
        }
    },

    computed: {
        recruitmentSwitchLabel() {
            if (this.recruitmentSwitch == true) {
                return "nabór letni";
            } else {
                return "nabór zimowy";
            }
        },

        levelOfStudyHandle: {
            set(newValue) {
                this.levelOfStudy = newValue;
                this.filteredStudyList = this.filter();
            },
            get() {}
        },

        formOfStudyHandle: {
            // setter
            set(newValue) {
                this.formOfStudy = newValue;
                this.filteredStudyList = [];
                this.filteredStudyList = this.filter();
            },
            get() {}
        },

        switchHandle: {
            // setter
            set(newValue) {
                this.recruitmentSwitch = newValue;
                this.filteredStudyList = this.filter();
            },
            get() {
                return true;
            }
        }
    },
    mounted() {
        this.categoryType = this.$store.state.categoryTypeData.categoryType;
    },

    async created() {
        this.recruitmentSwitch = true;
        this.action = 1;
        this.filteredStudyList = this.studyList;
    }
};
</script>
